import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const fetchOverrideHistory = createAsyncThunk("fetchOverrideHistory", async ({ page, limit, filters }) => {
    const params = new URLSearchParams({
        page: page || 1,
        limit: limit || 20,
        distributorCode: filters?.distributorCode || "",
        productId: filters?.productId || "",
        direction: filters?.direction || "",
        dateFrom: filters?.dateFrom || "",
        dateTo: filters?.dateTo || "",
    });

    const response = await axiosHttp.get(`replenishment/overrides?${params}`);
    return response.data;
});

const OverrideHistorySlice = createSlice({
    name: "OverrideHistorySlice",
    initialState: {
        isLoading: false,
        data: [],
        error: null,
        total: 0,
        page: 1,
        limit: 20,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchOverrideHistory.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchOverrideHistory.fulfilled, (state, action) => {
            state.isLoading = false;
            const payload = action.payload;
            const rawData = payload?.data;
            const arg = action.meta.arg;
            state.data = Array.isArray(rawData?.data) ? rawData.data : (Array.isArray(rawData) ? rawData : []);

            const total = rawData?.totalDocs || rawData?.total || payload?.pagination?.totalRecords || payload?.total || rawData?.count;
            if (total !== undefined) state.total = total;

            state.page = rawData?.page || payload?.pagination?.currentPage || (rawData?.offset !== undefined ? Math.floor(rawData.offset / (rawData.limit || 20)) + 1 : arg.page || 1);
        });
        builder.addCase(fetchOverrideHistory.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.error?.message;
        });
    },
});

export default OverrideHistorySlice.reducer;
